import { selectCurrentSearch, setSearch } from "@/entities/marketing-campaign"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Search } from "@/shared/ui/search"
import { Link } from "react-router-dom"

export const MarketingCampaignsFilters = () => {
    const search = useAppSelector(selectCurrentSearch)
    const dispatch = useAppDispatch()

    const handleChange = (val: string) => {
        dispatch(setSearch(val))
    }

    return (
        <div className="w-full flex justify-end gap-2">
            <Search value={search} onChange={handleChange} />
            <div className="filter_button !w-fit flex items-center">
                <Link to={`/marketing-campaigns/create`}>
                    Создать кампанию
                </Link>
            </div>
        </div>
    )
}